import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";

const styles = {
  confirmed: "bg-emerald-100 text-emerald-800",
  rescheduled: "bg-blue-100 text-blue-800",
  pending: "bg-amber-100 text-amber-800",
  completed: "bg-slate-200 text-slate-800",
  cancelled: "bg-red-100 text-red-700",
};

export default function AdminAppointments() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await api.get("/admin/appointments", { params: { status } });
      setItems(data); setLoading(false);
    })();
  }, [status]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center gap-3">
        <h1 className="text-3xl font-bold text-slate-900">Appointments</h1>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="rounded-xl w-40"><SelectValue /></SelectTrigger>
          <SelectContent>
            {["all", "confirmed", "rescheduled", "completed", "cancelled"].map((s) =>
              <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="doccare-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left"><tr>
            <th className="p-3">ID</th><th className="p-3">Patient</th><th className="p-3">Doctor</th>
            <th className="p-3 hidden md:table-cell">Date</th><th className="p-3">Status</th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="p-8 text-center"><Loader2 className="w-5 h-5 mx-auto animate-spin text-slate-400" /></td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-500">Nothing here</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-slate-100">
                <td className="p-3 font-mono text-xs text-slate-500">#{a.id.slice(0, 8)}</td>
                <td className="p-3 font-semibold">{a.patient.name}</td>
                <td className="p-3 text-slate-700">{a.doctor.name}<div className="text-xs text-emerald-700">{a.doctor.specialty}</div></td>
                <td className="p-3 hidden md:table-cell text-slate-600">{a.date} · {a.start_time}</td>
                <td className="p-3"><Badge className={`rounded-full ${styles[a.status]}`}>{a.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
